import React from "react";
import clsx from "clsx";
import useStyles from "./styles";

export default function DesktopAboutKm() {
  const classes = useStyles();
  const socialMedia = [
    {
      src: "https://km-landing.s3.ap-south-1.amazonaws.com/Images/km-home-page-2025/fb-icon.svg",
      url: "https://www.facebook.com/KheloMore/",
      alt: "facebook",
    },
    {
      src: "https://km-landing.s3.ap-south-1.amazonaws.com/Images/km-home-page-2025/insta-icon.svg",
      url: "https://www.instagram.com/khelomoreindia/",
      alt: "instagram",
    },
    {
      src: "https://km-landing.s3.ap-south-1.amazonaws.com/Images/km-home-page-2025/linkedin-icon.svg",
      url: "https://www.linkedin.com/company/khelomore/",
      alt: "linkedin",
    },
    {
      src: "https://km-landing.s3.ap-south-1.amazonaws.com/Images/km-home-page-2025/x-2025.svg",
      url: "https://x.com/KheloMore",
      alt: "x (twitter)",
    },
    {
      src: "https://km-landing.s3.ap-south-1.amazonaws.com/Images/km-home-page-2025/youtube-icon.svg",
      url: "https://www.youtube.com/channel/UC9SRqiqrQ1v9RoNX-Lnmqbg",
      alt: "youtube",
    },
  ];
  return (
    <>
      <main>
        <div className={classes.containerPadding}>
          <img
            className={clsx(classes.heroImg, classes.w100)}
            src="https://km-landing.s3.ap-south-1.amazonaws.com/Images/km-home-page-2025/km-summary.png"
            alt="km-summary"
          />
        </div>
        <div
          className={clsx(
            classes.flex,
            classes.spaceBw,
            classes.alignStart,
            classes.containerPadding
          )}
        >
          <h1 className={classes.w40}>
            <span className={classes.playText}>KheloMore’s Vision</span>
            <h2 className={classes.tapHead}>
            Beyond just an app to book courts
            </h2>
          </h1>
          <div className={clsx(classes.w15,classes.mt140)}>
            <img
              className={classes.mArrow}
              src="https://km-landing.s3.ap-south-1.amazonaws.com/Images/km-home-page-2025/movement-arrow.png"
              alt="arrow"
            />
          </div>
          <div className={clsx(classes.w40,classes.mt100)}>
            <h2 className={classes.tapHead}>
            A movement to bring sport back into everyday life.
            </h2>
          </div>
        </div>
        <div>
          <img
            className={clsx(classes.heroImg, classes.w100)}
            src="https://km-landing.s3.ap-south-1.amazonaws.com/Images/km-home-page-2025/km-community.png"
            alt="km-summary"
          />
        </div>
        {/* next game meetup */}
        <div
          className={clsx(
            classes.flex,
            classes.spaceBw,
            classes.alignStart,
            classes.containerPadding
          )}
        >
          <div className={classes.w48}>
            <span className={classes.playText}>Tap and Play</span>
            <h2 className={classes.tapHead}>
              Your Next Game is <br /> One Tap Away
            </h2>
            <p className={classes.tapPara}>
              No group chats. No calling venues. Just open the app, pick your
              sport, choose your time, and book a court nearby. It’s as easy as
              that.
            </p>
            <p className={clsx(classes.tapPara, classes.mt16)}>
              Discover a wide range of courts and turfs for 30+ variety of
              sports.
            </p>
            <div className={classes.inlineBlock}>
              <a className={classes.cta} href="https://www.khelomore.com/sports-venues" target="_blank">
                Book a Court Now
                <img
                  className={clsx(classes.flex, classes.arrow)}
                  src="https://km-landing.s3.ap-south-1.amazonaws.com/Images/km-home-page-2025/right-arrow.png"
                  alt="right-arrow"
                />
              </a>
            </div>
          </div>
          <div className={classes.w48}>
            <img
              className={clsx(classes.meetupImg, classes.w100)}
              src="https://km-landing.s3.ap-south-1.amazonaws.com/Images/km-home-page-2025/user-meet.png"
              alt="user meet"
            />
          </div>
        </div>
        {/* user meet */}
        <div
          className={clsx(
            classes.flex,
            classes.spaceBw,
            classes.alignStart,
            classes.containerPadding
          )}
        >
          <div className={classes.w48}>
            <img
              className={clsx(classes.meetupImg, classes.w100)}
              src="https://km-landing.s3.ap-south-1.amazonaws.com/Images/km-home-page-2025/user-group.png"
              alt="user group"
            />
          </div>
          <div className={classes.w48}>
            <span className={classes.playText}>Bring Your A-Game</span>
            <h2 className={classes.tapHead}>
              Play It. Own It. <br />
              Win It.
            </h2>
            <p className={classes.tapPara}>
              From beginner leagues to full-blown tournaments, bring your
              community together through sports. Search for your favourite
              games, invite players, and make it a match to remember - all
              through KheloMore.
            </p>
            <div className={classes.inlineBlock}>
              <a className={classes.cta} href="https://www.khelomore.com/events/explore-events" target="_blank">
                Join an Event
                <img
                  className={clsx(classes.flex, classes.arrow)}
                  src="https://km-landing.s3.ap-south-1.amazonaws.com/Images/km-home-page-2025/right-arrow.png"
                  alt="right-arrow"
                />
              </a>
            </div>
          </div>
        </div>
        {/* coaching */}
        <div className={classes.containerPadding}>
          <div>
            <span className={classes.playText}>Doorstep Coaching</span>
            <h2 className={classes.tapHead}>Coaching That Comes Home</h2>
            <p className={classes.tapPara}>
              No traffic, no stress. Get top-notch coaching right inside your
              apartment complex for kids, adults, and anyone looking to level up
              their game, literally from home.
            </p>
            <div className={classes.heroContainer}>
              <img
                className={clsx(classes.heroImg, classes.w100)}
                src="https://km-landing.s3.ap-south-1.amazonaws.com/Images/km-home-page-2025/coaching-infra.png"
                alt="coaching infra"
              />
            </div>
          </div>
          <div className={classes.inlineBlock}>
            <a className={classes.cta} href="https://www.khelomore.com/sports-coaching" target="_blank">
              Get Coaching at Home
              <img
                className={clsx(classes.flex, classes.arrow)}
                src="https://km-landing.s3.ap-south-1.amazonaws.com/Images/km-home-page-2025/right-arrow.png"
                alt="right-arrow"
              />
            </a>
          </div>
        </div>
        {/* card for blog and event */}
        <div
          className={clsx(classes.flex, classes.spaceBw, classes.alignCenter)}
        >
          <div className={clsx(classes.blogCard,classes.w48)}>
            <span className={clsx(classes.blogText,classes.tapPara)}>Blogs</span>
            <h2 className={classes.playBook}>The Playbook</h2>
            <p className={clsx(classes.blogText,classes.tapPara)}>
              From grassroots journeys to game-changing trends - dive into the
              world of sports, community, and culture. Whether you’re a weekend
              warrior or a curious fan, we’ve got something for you.
            </p>
            <div className={classes.inlineBlock}>
              <a className={clsx(classes.blogCta,classes.cta)} href="https://blog.khelomore.com/" target="_blank">
                Read the Blog
                <img
                  className={clsx(classes.flex,classes.arrow)}
                  src="https://km-landing.s3.ap-south-1.amazonaws.com/Images/km-home-page-2025/black-arrow.png"
                  alt="arrow"
                />
              </a>
            </div>
          </div>
          <div className={clsx(classes.eventCard,classes.w48)}>
            <span className={clsx(classes.blogText,classes.tapPara)}>Corporate Events</span>
            <h2 className={classes.playBook}>Game Day, The Office Way</h2>
            <p className={clsx(classes.blogText,classes.tapPara)}>
              Skip the boring offsite. Host a sports day your team will actually
              enjoy - with expert coaches, curated experiences, and just the
              right amount of friendly fire.
            </p>
            <div className={classes.inlineBlock}>
              <a className={clsx(classes.blogCta,classes.cta)} href="https://docs.google.com/forms/d/e/1FAIpQLSfFTFxlpwh82jPgVkKMua7XP0ijLKcc2rEEw7wk5YV48zen-Q/viewform?usp=header" target="_blank">
                Plan a Corporate Event
                <img
                  className={clsx(classes.flex,classes.arrow)}
                  src="https://km-landing.s3.ap-south-1.amazonaws.com/Images/km-home-page-2025/black-arrow.png"
                  alt="arrow"
                />
              </a>
            </div>
          </div>
        </div>
        {/* social media */}
        <div>
          <center className={classes.mtb32}>
            {socialMedia?.map((item, idx) => (
              <a target="_blank" href={item?.url} key={item?.alt}>
                <img
                  className={classes.socialIcon}
                  src={item?.src}
                  alt={item?.alt}
                />
              </a>
            ))}
          </center>
        </div>
      </main>
    </>
  );
}
